export const NUM_OF_COMPENSATIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const WIFI_REGIONS = ['', 'North America & Central America', 'South America', 'Trans-Atlantic', 'Trans-Pacific'];